/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { PartnerIntentRequest } from "./PartnerIntentRequest";

/**
 * Request body for completing user onboarding
 */
export interface CompleteOnboardingRequest {
  /** Current conversation ID to migrate */
  conversation_id?: string | null;
  /** Partner referral information */
  partner_intent?: PartnerIntentRequest | null;
}
